import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { Container, Graphics, IDestroyOptions, Text, TextStyle } from "pixi.js";

export class DetailsView extends Container {

    private readonly canvasScaler: ICanvasScaler;

    private backgound: Graphics;
    private closeText: Text;

    public constructor(canvasScaler: ICanvasScaler) {
        super();
        this.canvasScaler = canvasScaler;
        this.build();
        this.closeText.on("pointerdown", this.hide, this);
        this.hide();
    }

    public show(): void {
        this.visible = true;
    }

    public hide(): void {
        this.visible = false;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.closeText.off("pointerdown", this.hide, this);
        super.destroy(options);
    }

    private build() {
        this.backgound = new Graphics()
            .beginFill(0x2b2b2b, 0.8)
            .drawRect(0, 0, this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);
        this.backgound.eventMode = "static";
        this.addChild(this.backgound);

        this.closeText = new Text("Close", new CloseTextStyle());
        this.closeText.interactive = true;
        const closeBg = new Graphics()
            .beginFill(0xffffff, 0.9)
            .drawRect(0, 0, this.closeText.width + 25, this.closeText.height + 10);
        this.closeText.position.set((closeBg.width - this.closeText.width) * 0.5, (closeBg.height - this.closeText.height) * 0.5);
        closeBg.addChild(this.closeText);

        closeBg.position.set(this.canvasScaler.referenceWidth - this.closeText.width - 100, 100);
        this.addChild(closeBg);
    }
}

class CloseTextStyle extends TextStyle {
    public constructor() {
        super({
            fontSize: 25,
            fill: 0xffffff,
            stroke: 0x000000,
            strokeThickness: 5
        })
    }
}